module.exports = __webpack_public_path__ + "img/purchased.fccfbe9a.webp";